export class MainUiFilter 
{
	constructor(options = {name: "MainUiFilter"})
	{
		this.name = options.name;

        this.init();
	}

    init() {
        this.learnedLessons();
        this.checklistsAndPrescriptions();
    }

    checklistsAndPrescriptions() {
        const LIST_ID = BX.message("LIST_ID_CHECKLIST_IMPROVEMENT_REGISTRY");

        // codependent selectors filtration
        BX.addCustomEvent("bx.filter.field:change", async function(event) {
            let oFilter = event.target.parent;
            if (oFilter.getParam("FILTER_ID") != `lists_list_elements_${LIST_ID}`) {
                return true;
            }

            let propIdToCode = BX.message("LIST_ID_CHECKLIST_IMPROVEMENT_REGISTRY_arPropWellFilterIdToCode");
            let arWellFieldsInfoInOrder = BX.message("LIST_ID_CHECKLIST_IMPROVEMENT_REGISTRY_arPropWellFilterInfoInOrder");
            let target = BX.getEventTarget(event);
            let iChangedFieldId = target.id.replace("PROPERTY_", "");

            if (iChangedFieldId in propIdToCode) {
                let arFieldValues = oFilter.getFilterFieldsValues();

                // delete all fields
                for (let rewindPropId in propIdToCode) {
                    oFilter.getPreset().removeField({
                        "NAME": `PROPERTY_${rewindPropId}`
                    });
                }

                let sAjaxFilterChangedFieldCode = arWellFieldsInfoInOrder.find(el => el["ID"] == iChangedFieldId)["CODE"];
                let arAjaxFilterFieldValues = {};
                for (let i = 0; i < arWellFieldsInfoInOrder.length; ++i) {
                    let sPropValueCode = "PROPERTY_" + arWellFieldsInfoInOrder[i]["ID"];
                    let sPropCode = arWellFieldsInfoInOrder[i]["CODE"];
                    arAjaxFilterFieldValues[sPropCode] = ((arFieldValues[sPropValueCode] !== undefined)
                        ? arFieldValues[sPropValueCode]
                        : "");
                }

                delete arAjaxFilterFieldValues["NPV_NAME"];
                let oAjaxFilter = {
                    sChangedFieldCode: sAjaxFilterChangedFieldCode,
                    arFieldValues: arAjaxFilterFieldValues 
                };

                let arFilteredOptions = await window.$.ajax({
                    type: "POST",
                    url: "/api/v1/lists/",
                    contentType: "json",
                    data: JSON.stringify({
                        "method": "getWellCodependentFields",
                        "data": {
                            "iListId": LIST_ID,
                            "arFilter": oAjaxFilter
                        }
                    }, null, 2),
                });
                arFilteredOptions = JSON.parse(arFilteredOptions)["data"];

                // show all codependent filter fields
                let arFields = oFilter.getParam("FIELDS");
                let arAddedFields = [];
                for (let j = 0; j < arWellFieldsInfoInOrder.length; ++j) {
                    for (let i = 0; i < arFields.length; ++i) {
                        if (arFields[i].NAME == `PROPERTY_${arWellFieldsInfoInOrder[j]["ID"]}`) {
                            if (arAddedFields.indexOf(arFields[i].NAME) != -1) {
                                continue;
                            }

                            // update select field options from ajax request result
                            let sPropCode = propIdToCode[arFields[i].NAME.replace("PROPERTY_", "")];
                            if (arFilteredOptions["updateFieldsItems"][sPropCode] == true) {
                                arFields[i].ITEMS = arFilteredOptions["fieldsItems"][sPropCode];
                            }

                            // set selected value, it's new added field return old selected value
                            if (arFieldValues[arFields[i].NAME] !== undefined) {
                                for (let k = 0; k < arFields[i].ITEMS.length; ++k) {
                                    if (arFieldValues[arFields[i].NAME] == arFields[i].ITEMS[k].VALUE) {
                                        arFields[i].VALUE = arFields[i].ITEMS[k];
                                    }
                                }
                            }

                            arAddedFields.push(arFields[i].NAME);
                            oFilter.getPreset().addField(arFields[i]);
                        }
                    }
                }

                oFilter.syncFields();
            }

            return {};
        });

        // change string values types to lists
        BX.addCustomEvent("BX.Filter.Search:beforeSquaresUpdate", function (presetData, filterSearch) {
            let filter = filterSearch.parent;
            if (filter.getParam("FILTER_ID") != `lists_list_elements_${LIST_ID}`) {
                return true;
            }
            let arFieldToListConfig = {
                "Куст": {"CODE": "BUSH"},
                "Скважина": {"CODE": "WELL_NAME", "NAME": BX.message("LIST_ID_CHECKLIST_IMPROVEMENT_REGISTRY_PROP_ID_WELL_NAME")},
                "Проект": {"CODE": "PROJECT_NAME"},
                "Первый ответственный": {"CODE": "FIRST_RESPONSIBLE"},
                "Последний ответственный": {"CODE": "LAST_RESPONSIBLE"}
            };

            filter.getParam("FIELDS").forEach(obField => {
                if (arFieldToListConfig[obField.LABEL] !== undefined) {
                    if (arFieldToListConfig[obField.LABEL].NAME !== undefined) {
                        if (`PROPERTY_${arFieldToListConfig[obField.LABEL].NAME}` != obField.NAME) {
                            return;
                        }
                    }
                    let sFldCode = arFieldToListConfig[obField.LABEL].CODE;
                    let arItems = BX.message(`LIST_ID_CHECKLIST_IMPROVEMENT_REGISTRY_VALUES_${sFldCode}`);
                    if (typeof arItems == "string") {
                        arItems = eval(arItems);
                    }
                    obField.ITEMS = arItems;
                    obField.TYPE = "SELECT";
                    if (obField.VALUE == "") {
                        obField.VALUE = {"NAME": "Не указан", "VALUE": ""};
                    } else {
                        let oItemValue = arItems.find(item => {
                            if (item.VALUE == obField.VALUE) {
                                return true;
                            }
                            return false;
                        });
                        if (oItemValue !== undefined) {
                            obField.VALUE = oItemValue;
                        } else {
                            obField.VALUE = {"NAME": "Не указан", "VALUE": ""};
                        }
                    }
                }
            });

            filter.getParam("PRESETS").forEach(obPreset => {
                obPreset.FIELDS.forEach(obField => {
                    if (arFieldToListConfig[obField.LABEL] !== undefined) {
                        if (arFieldToListConfig[obField.LABEL].NAME !== undefined) {
                            if (`PROPERTY_${arFieldToListConfig[obField.LABEL].NAME}` != obField.NAME) {
                                return;
                            }
                        }
                        let sFldCode = arFieldToListConfig[obField.LABEL].CODE;
                        let arItems = eval(BX.message(`LIST_ID_CHECKLIST_IMPROVEMENT_REGISTRY_VALUES_${sFldCode}`));
                        obField.ITEMS = arItems;
                        obField.TYPE = "SELECT";
                        if (obField.VALUE == "") {
                            obField.VALUE = {"NAME": "Не указан", "VALUE": ""};
                        } else {
                            let oItemValue = arItems.find(item => {
                                if (item.VALUE == obField.VALUE) {
                                    return true;
                                }
                                return false;
                            });
                            if (oItemValue !== undefined) {
                                obField.VALUE = oItemValue;
                            } else {
                                obField.VALUE = {"NAME": "Не указан", "VALUE": ""};
                            }
                        }
                    }
                });
            });
        });
    }

    // List: Извлеченные уроки
    learnedLessons() {
        const iLearnedLessonsListId = BX.message("LIST_ID_LEARNED_LESSONS");

        BX.addCustomEvent("bx.filter.field:change", async function(event) {
            let oFilter = event.target.parent;
            if (oFilter.getParam("FILTER_ID") != `lists_list_elements_${iLearnedLessonsListId}`) {
                return true;
            }

            let propIdToCode = BX.message("LIST_ID_LEARNED_LESSONS_arPropNpvWellFilterIdToCode");
            let iChangedFieldId = BX.getEventTarget(event).id.replace("PROPERTY_", "");
            let aFieldsInfoInOrder = BX.message("LIST_ID_LEARNED_LESSONS_arPropNpvWellFilterInfoInOrder");

            if (iChangedFieldId in propIdToCode) {
                let aFieldValues = oFilter.getFilterFieldsValues();

                // remove handled connected properties
                for (let removedPropId in propIdToCode) {
                    oFilter.getPreset().removeField({
                        "NAME": `PROPERTY_${removedPropId}`
                    });
                }

                let aFilteredItems = [];
                let sChangedPropCode = propIdToCode[iChangedFieldId];
                let aData = {};
                switch (sChangedPropCode) {
                    case "NPV_CLASS":
                        let iClassId = +aFieldValues[`PROPERTY_${iChangedFieldId}`];
                        if (iClassId > 0) { aData = {"CLASS_ID": iClassId}; }
                        aFilteredItems["NPV_KIND"] = await fetch("/api/v1/npv/", {
                            method: "POST",
                            body: JSON.stringify({
                                method: "getKindsList",
                                data: aData
                            })
                        })
                        .then(oResponse => oResponse.json())
                        .then(oJson => {
                            let oResult = oJson.data.map((oItem, iIndex, aArray) => {
                                return {
                                    "NAME": oItem["NAME"],
                                    "VALUE": oItem["ID"]
                                };
                            });
                            oResult.unshift({"NAME": "Не указан", "VALUE": ""});
                            return oResult;
                        });

                        // reset type
                        aFilteredItems["NPV_TYPE"] = await fetch("/api/v1/npv/", {
                            method: "POST",
                            body: JSON.stringify({
                                method: "getTypesList",
                                data: {}
                            })
                        })
                        .then(oResponse => oResponse.json())
                        .then(oJson => {
                            let oResult = oJson.data.map((oItem, iIndex, aArray) => {
                                return {
                                    "NAME": oItem["NAME"],
                                    "VALUE": oItem["ID"]
                                };
                            });
                            oResult.unshift({"NAME": "Не указан", "VALUE": ""});
                            return oResult;
                        });
                        break;
                    case "NPV_KIND":
                        let iKindId = +aFieldValues[`PROPERTY_${iChangedFieldId}`];
                        if (iKindId > 0) { aData = {"KIND_ID": iKindId}; }
                        aFilteredItems["NPV_TYPE"] = await fetch("/api/v1/npv/", {
                            method: "POST",
                            body: JSON.stringify({
                                method: "getTypesList",
                                data: aData
                            })
                        })
                        .then(oResponse => oResponse.json())
                        .then(oJson => {
                            let oResult = oJson.data.map((oItem, iIndex, aArray) => {
                                return {
                                    "NAME": oItem["NAME"],
                                    "VALUE": oItem["ID"]
                                };
                            });
                            oResult.unshift({"NAME": "Не указан", "VALUE": ""});
                            return oResult;
                        });
                        break;
                    default:
                        break;
                }

                // show removed handled connected properties in sorted order
                let aFilterFields = oFilter.getParam("FIELDS");
                let aAddedFields = [];
                for (let i = 0; i < aFieldsInfoInOrder.length; ++i) {
                    for (let j = 0; j < aFilterFields.length; ++j) {
                        if (aFilterFields[j].NAME == `PROPERTY_${aFieldsInfoInOrder[i]["ID"]}`) {
                            if (aAddedFields.indexOf(aFilterFields[j].NAME) != -1) { // check for depended field
                                continue;
                            }
                            aAddedFields.push(aFilterFields[j].NAME);

                            // replace property items with filtered items
                            let iFilterFieldId = aFilterFields[j].NAME.replace("PROPERTY_", "");
                            let sFilterFieldCode = propIdToCode[iFilterFieldId];
                            if (aFilteredItems[sFilterFieldCode] !== undefined) {
                                aFilterFields[j].VALUE = {"NAME": "Не указан", "VALUE": ""};
                                aFilterFields[j].ITEMS = aFilteredItems[sFilterFieldCode];
                            }

                            // set selected values
                            if (aFieldValues[aFilterFields[j].NAME] !== undefined) {
                                for (let k = 0; k < aFilterFields[j].ITEMS.length; ++k) {
                                    if (aFieldValues[aFilterFields[j].NAME] == aFilterFields[j].ITEMS[k].VALUE) {
                                        aFilterFields[j].VALUE = aFilterFields[j].ITEMS[k];
                                        break;
                                    }
                                }
                            }

                            oFilter.getPreset().addField(aFilterFields[j]);
                        }
                    }
                }

                oFilter.syncFields();
            }
        });

        // codependent selectors filtration
        BX.addCustomEvent("bx.filter.field:change", async function(event) {
            let oFilter = event.target.parent;
            if (oFilter.getParam("FILTER_ID") != `lists_list_elements_${iLearnedLessonsListId}`) {
                return true;
            }

            // let oFilter = BX.Main.filterManager.getById(`lists_list_elements_${iLearnedLessonsListId}`);
            let propIdToCode = BX.message("LIST_ID_LEARNED_LESSONS_arPropWellFilterIdToCode");
            let arWellFieldsInfoInOrder = BX.message("LIST_ID_LEARNED_LESSONS_arPropWellFilterInfoInOrder");
            let target = BX.getEventTarget(event);
            let iChangedFieldId = target.id.replace("PROPERTY_", "");

            if (iChangedFieldId in propIdToCode) {
                let arFieldValues = oFilter.getFilterFieldsValues();

                // delete all fields
                for (let rewindPropId in propIdToCode) {
                    oFilter.getPreset().removeField({
                        "NAME": `PROPERTY_${rewindPropId}`
                    });
                }

                let sAjaxFilterChangedFieldCode = arWellFieldsInfoInOrder.find(el => el["ID"] == iChangedFieldId)["CODE"];
                let arAjaxFilterFieldValues = {};
                for (let i = 0; i < arWellFieldsInfoInOrder.length; ++i) {
                    let sPropValueCode = "PROPERTY_" + arWellFieldsInfoInOrder[i]["ID"];
                    let sPropCode = arWellFieldsInfoInOrder[i]["CODE"];
                    arAjaxFilterFieldValues[sPropCode] = ((arFieldValues[sPropValueCode] !== undefined)
                        ? arFieldValues[sPropValueCode]
                        : "");
                }

                delete arAjaxFilterFieldValues["NPV_NAME"];
                let oAjaxFilter = {
                    sChangedFieldCode: sAjaxFilterChangedFieldCode,
                    arFieldValues: arAjaxFilterFieldValues 
                };

                let arFilteredOptions = await window.$.ajax({
                    type: "POST",
                    url: "/api/v1/lists/",
                    contentType: "json",
                    data: JSON.stringify({
                        "method": "getWellCodependentFields",
                        "data": {
                            "iListId": iLearnedLessonsListId,
                            "arFilter": oAjaxFilter
                        }
                    }, null, 2),
                });
                arFilteredOptions = JSON.parse(arFilteredOptions)["data"];

                // show all codependent filter fields
                let arFields = oFilter.getParam("FIELDS");
                let arAddedFields = [];
                for (let j = 0; j < arWellFieldsInfoInOrder.length; ++j) {
                    for (let i = 0; i < arFields.length; ++i) {
                        if (arFields[i].NAME == `PROPERTY_${arWellFieldsInfoInOrder[j]["ID"]}`) {
                            if (arAddedFields.indexOf(arFields[i].NAME) != -1) {
                                continue;
                            }

                            // update select field options from ajax request result
                            let sPropCode = propIdToCode[arFields[i].NAME.replace("PROPERTY_", "")];
                            if (arFilteredOptions["updateFieldsItems"][sPropCode] == true) {
                                arFields[i].ITEMS = arFilteredOptions["fieldsItems"][sPropCode];
                            }

                            // set selected value, it's new added field return old selected value
                            if (arFieldValues[arFields[i].NAME] !== undefined) {
                                for (let k = 0; k < arFields[i].ITEMS.length; ++k) {
                                    if (arFieldValues[arFields[i].NAME] == arFields[i].ITEMS[k].VALUE) {
                                        arFields[i].VALUE = arFields[i].ITEMS[k];
                                    }
                                }
                            }

                            arAddedFields.push(arFields[i].NAME);
                            oFilter.getPreset().addField(arFields[i]);
                        }
                    }
                }

                oFilter.syncFields();
            }

            return {};
        });

        // change string values types to lists
        BX.addCustomEvent("BX.Filter.Search:beforeSquaresUpdate", function (presetData, filterSearch) {
            let filter = filterSearch.parent;
            if (filter.getParam("FILTER_ID") != `lists_list_elements_${iLearnedLessonsListId}`) {
                return true;
            }
            let arFieldToListConfig = {
                "Скважина":  {"CODE": "WELL_NAME"},
                "Куст":      {"CODE": "BUSH"},
                "Проект":    {"CODE": "PROJECT_NAME"},
                "Секция":    {"CODE": "SECTION"},
                "Операция при которой произошло опережение/отставание": {"CODE": "OP_LAG_ADVANCE"},
                "Класс НПВ": {"CODE": "NPV_CLASS"},
                "Вид НПВ":   {"CODE": "NPV_TYPE"},
                "Тип НПВ":   {"CODE": "NPV_KIND"},
                "Первый ответственный": {"CODE": "FIRST_RESPONSIBLE"},
                "Последний ответственный": {"CODE": "LAST_RESPONSIBLE"}
            };

            filter.getParam("FIELDS").forEach(obField => {
                if (arFieldToListConfig[obField.LABEL] !== undefined) {
                    let sFldCode = arFieldToListConfig[obField.LABEL].CODE;
                    let arItems = BX.message(`LIST_ID_LEARNED_LESSONS_VALUES_${sFldCode}`);
                    if (typeof arItems == "string") {
                        arItems = eval(arItems);
                    }
                    obField.ITEMS = arItems;
                    obField.TYPE = "SELECT";
                    if (obField.VALUE == "") {
                        obField.VALUE = {"NAME": "Не указан", "VALUE": ""};
                    } else {
                        let oItemValue = arItems.find(item => {
                            if (item.VALUE == obField.VALUE) {
                                return true;
                            }
                            return false;
                        });
                        if (oItemValue !== undefined) {
                            obField.VALUE = oItemValue;
                        } else {
                            obField.VALUE = {"NAME": "Не указан", "VALUE": ""};
                        }
                    }
                }
            });

            filter.getParam("PRESETS").forEach(obPreset => {
                obPreset.FIELDS.forEach(obField => {
                    if (arFieldToListConfig[obField.LABEL] !== undefined) {
                        let sFldCode = arFieldToListConfig[obField.LABEL].CODE;
                        let arItems = eval(BX.message(`LIST_ID_LEARNED_LESSONS_VALUES_${sFldCode}`));
                        obField.ITEMS = arItems;
                        obField.TYPE = "SELECT";
                        if (obField.VALUE == "") {
                            obField.VALUE = {"NAME": "Не указан", "VALUE": ""};
                        } else {
                            let oItemValue = arItems.find(item => {
                                if (item.VALUE == obField.VALUE) {
                                    return true;
                                }
                                return false;
                            });
                            if (oItemValue !== undefined) {
                                obField.VALUE = oItemValue;
                            } else {
                                obField.VALUE = {"NAME": "Не указан", "VALUE": ""};
                            }
                        }
                    }
                });
            });
        });

        // hide fields by title
        BX.addCustomEvent("BX.Filter.Search:beforeSquaresUpdate", function (presetData, filterSearch) {
            let filter = filterSearch.parent;
            if (filter.getParam("FILTER_ID") != `lists_list_elements_${iLearnedLessonsListId}`) {
                return true;
            }
            filter.params.FIELDS = filter.getParam("FIELDS").filter(item => {
                return ! [
                    "Категория НПВ 1",
                    "Категория НПВ 2",
                    "Категория НПВ 3",
                    "Категория НПВ 4"
                ].includes(item.LABEL);
            });
        });
    }
}
